import { Box, Button, Stack } from '@mui/material';
import { useState } from 'react';
import useBundleTranslation from 'i18n';
import { Popup, PopupSettings } from 'components/common/popup/Popup';

interface IProps {
    conciergeMessage: React.ReactNode;
    content: React.ReactNode;
}

export default function ExpandButton({ content, conciergeMessage }: IProps) {
    const { t } = useBundleTranslation(['app/concierge/widget']);
    const [showResultPopup, setShowResultPopup] = useState(false);

    const popupSettings: PopupSettings = {
        title: t('expand.title'),
        noButtons: true,
    };

    const onClose = () => {
        setShowResultPopup(false);
    };

    return (
        <>
            <Button variant={'text'} onClick={() => setShowResultPopup(true)}>
                {t('expand.button')}
            </Button>
            {showResultPopup && (
                <Popup
                    settings={popupSettings}
                    onHide={onClose}
                    open
                    maxWidth={'popupXl'}
                    // MI-30425: the Concierge panel sits at theme.zIndex.modal + 1 (fixed, full-height,
                    // pointer-interactive) so it paints over — and eats clicks/scroll for — a plain
                    // MUI Dialog at the library default of theme.zIndex.modal.
                    sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
                >
                    <Stack spacing={2}>
                        <Box sx={{ position: 'relative' }}>{conciergeMessage}</Box>
                        {content}
                    </Stack>
                </Popup>
            )}
        </>
    );
}
